import { render, staticRenderFns } from "./CardInstrumentSelected.vue?vue&type=template&id=2424651a&scoped=true"
import script from "./CardInstrumentSelected.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardInstrumentSelected.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardInstrumentSelected.vue?vue&type=style&index=0&id=2424651a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424651a",
  null
  
)

export default component.exports